<template>
<el-container class="layout" :style="{paddingBottom: $store.state.isPage && !isMobiles ? '100px' : '0px'}">
    <el-header :class="['layout-header', isSticky ? 'sticky' : '']">
        <HeadBar></HeadBar>
    </el-header>
    <el-main>
        <AppMain></AppMain>
    </el-main>
    <el-footer v-if="$store.state.isPage" class="box-footer" style="height: 1.6rem;">
        <Footer></Footer>
    </el-footer>
    <el-dialog v-if="list.length" title="公告" :visible.sync="dialogVisible" width="40%" :close-on-click-modal="false">
        <div class="ibo-box">
            <div class="box-con" v-for="(item, index) in list" :key="index + 'list'">
                <div class="con-time">{{ item.time }}</div>
                <div class="con-txt" :title="item.txt">
                    <a :href="`/static/pdf/${item.txt}.pdf`" target="_blank" rel="noopener noreferrer">{{ item.txt }}</a>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
    </el-dialog>
    <el-backtop></el-backtop>
</el-container>
</template>

<script>
import {
    HeadBar,
    SlideBar,
    AppMain,
    Footer
} from "./components";
import {
    isMobile
} from '../../libs/util'
export default {
    components: {
        HeadBar,
        SlideBar,
        AppMain,
        Footer
    },
    data() {
        return {
            isSticky: false,
            dialogVisible: true,
            list: [],
            isMobiles: false
        };
    },
    created() {
        this.list = this.$store.state.newsList.reduce((t, v) => {
            if (Date.now() - new Date(v.time).getTime() <= 86400000 * 7) {
                t.push(v)
            }
            return t
        }, [])
        window.onscroll = () => {
            var scrollTop =
                document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop > 0) {
                this.isSticky = true;
            } else {
                this.isSticky = false;
            }
        }
        this.isMobiles = isMobile()
    }
};
</script>

<style lang="less" scoped>
.layout {
    position: relative;
    min-height: 97.7vh;

    // padding-bottom: 100px;
    .el-main {
        padding-bottom: 0px;
    }

    .layout-header {
        height: 2.67rem !important;
        position: sticky;
        top: 0;
        z-index: 99;
    }

    .sticky {
        height: 2.67rem !important;
        color: white;
        background-color: #04497A;
    }

    .box-footer {
        position: absolute;
        bottom: 0;
        width: 100%;
        // background-color: #efefef;
    }
}

/deep/ .el-header {
    padding: 0;
}

/deep/ .el-main {
    padding: 0;
}

/deep/ .el-footer {
    padding: 0;
}

::-webkit-scrollbar-track-piece {
    //滚动条凹槽的颜色，还可以设置边框属性
    background-color: #f8f8f8;
}

::-webkit-scrollbar {
    //滚动条的宽度
    width: 9px;
    height: 9px;
}

::-webkit-scrollbar-thumb {
    //滚动条的设置
    background-color: #dddddd;
    background-clip: padding-box;
    min-height: 28px;
}

::-webkit-scrollbar-thumb:hover {
    background-color: #bbb;
}

.ibo-box {
    height: 300px;
    overflow-y: auto;

    .box-con {
        margin: 20px;

        .con-time {
            color: #e5314f;
        }

        .con-txt {
            cursor: pointer;
            // white-space: nowrap;
            // overflow: hidden;
            // text-overflow: ellipsis;
            padding: 5px 0px 10px;
            border-bottom: 1px dashed #dddddd;

            a {
                text-decoration: none;
                color: #2c3e50;
            }

            a:hover {
                color: #0476c3;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/layout/layout.vue